import * as CONSTANTS from './constants'

export const getInitialState = () => {
  return {
    dataLoading: true,
    data: {
    }
  };
}

const DirectoryPage = (state = getInitialState(), action) => {
  const { type, actionData } = action;

  switch (type) {
    case CONSTANTS.UPDATE_DIR_DATA:
      return Object.assign({}, state, {
        ...state,
        data: actionData.data,
        dataLoading: false
      })
    default:
      return state;
  }
}

export default DirectoryPage
